import './Dashboard.css';
import React, { useEffect, useState } from "react";
import axios from "axios";
import BoxGraph from './BoxGraph';
import Todo from '../Todo/Todo';
import SimpleLineChart from '../LineGraph/LineGraph';
import GradientPie from './DasshboardPie';
// Updated Card component to support three variations:
//   • isUserCard: shows New Users / Total Users
//   • isSpentWinningCard: shows Total Spent (left) and Winning Points (right)
//   • isPayoutCard: shows Payouts data (you can adjust these labels as needed)
const Card = ({
    title,
    color,
    image,
    data,
    growthRate,
    duration,
    isUserCard,
    isPayoutCard,
    isSpentWinningCard,
    isRevenueCard,
    newUsers,
    totalUsers,
    winningPoints,
     navigateTo

}) => (
    <div className="all-card dashboard-card-container">
        <div className="all-card-content dashboard-content">
            <h2>{title}</h2>
            <div className="all-time-container">
                <div className="all-time-left">
                    {isUserCard ? (
                        <div className="all-time-stats">
                            <div className="user-stats-left">
                                <p className="user-stats-label">New Users</p>
                                <p className="user-stats-value">{newUsers}</p>
                            </div>
                            <div className="vertical-line" />
                            <div className="user-stats-right">
                                <p className="user-stats-label">Total Users</p>
                                <p className="user-stats-value">{totalUsers}</p>
                            </div>
                        </div>
                    ) : isSpentWinningCard ? (
                        <div className="all-time-stats">
                            <div className="user-stats-left">
                                <p className="user-stats-label">Inflow</p>
                                <p className="user-stats-value"><span className="bid-amount dashboard-amount">₹</span> {data}</p>
                            </div>
                            <div className="vertical-line" />
                            <div className="user-stats-right">
                                <p className="user-stats-label">Outflow</p>
                                <p className="user-stats-value"><span className="bid-amount dashboard-amount">₹</span> {winningPoints}</p>
                            </div>
                        </div>
                    ) : isPayoutCard ? (
                        <div className="all-time-stats">
                            <div className="user-stats-left">
                                <p className="user-stats-label">Total</p>
                                <p className="user-stats-value"><span className="bid-amount dashboard-amount">₹</span> {data}</p>
                            </div>
                            <div className="vertical-line" />
                            <div className="user-stats-right">
                                <p className="user-stats-label">24 hours</p>
                                <p className="user-stats-value"><span className="bid-amount dashboard-amount">₹</span> 0</p>
                            </div>
                        </div>
                    ) : isRevenueCard ? (
                        <div className="all-time-stats">
                            <div className="user-stats-left">
                                <p className="user-stats-label">Total</p>
                                <p className="user-stats-value"><span className="bid-amount dashboard-amount">₹</span> {data}</p>
                            </div>
                            <div className="vertical-line" />
                            <div className="user-stats-right">
                                <p className="user-stats-label">24 hours</p>
                                <p className="user-stats-value"><span className="bid-amount dashboard-amount">₹</span> 0</p> {/* You can replace this with actual 24hr revenue if available */}
                            </div>
                        </div>
                    ) : (
                        <p className="all-time">{data}</p>
                    )}
                </div>
            </div>
        </div>
        <div className={`all-card-icon ${color}`}>
            <img src={image} alt={title} className="all-icon" />
        </div>
        {growthRate !== undefined && (
            <div className="order-footer">
                <div className="stats-background">
                    <span className={`growth-rate ${growthRate > 0 ? "increase" : "decrease"}`}>
                        {growthRate > 0 ? "▲" : "▼"} {Math.abs(growthRate)}%
                    </span>
                    <span>{duration}</span>
                    <a
                        href={`#${navigateTo}`}
                        onClick={(e) => {
                            e.preventDefault();
                            const todayStr = new Date().toISOString().split("T")[0];
                            localStorage.setItem("showExtraUsersInfo", "true");
                            localStorage.setItem("activeTab", navigateTo);
                            localStorage.setItem("userFilterDate", todayStr); // 🆕 Store today's date
                            window.location.reload(); // Refresh to re-render HomePage with new tab
                        }}
                    >
                        View More
                    </a>




                </div>
            </div>
        )}
    </div>
);

const Dashboard = () => {
    const [totalUsers, setTotalUsers] = useState(0);
    const [todayUsers, setTodayUsers] = useState(0);
    const [last24HoursUsers, setLast24HoursUsers] = useState(0);

    const [last24HoursGrowth, setLast24HoursGrowth] = useState(0);
    const [lastWeekGrowth, setLastWeekGrowth] = useState(0);
    const [totalSpent, setTotalSpent] = useState(0);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [lastWeekRevenueGrowth, setLastWeekRevenueGrowth] = useState(0);
    const [lastWeekSpentGrowth, setLastWeekSpentGrowth] = useState(0);
    const [userPoints, setUserPoints] = useState(0);
    const [totalWinningPoints, setTotalWinningPoints] = useState(0);
    const today = new Date();
    localStorage.setItem("extraType", "user-stats"); // or revenue, payout, etc.

    const bidStatsDateStr = today.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short"
    });
useEffect(() => {
  const fetchSummary = async () => {
    try {
      const res = await axios.get("https://prod-erp.nifty10.in/user/summary");
      const data = res.data;

      setTotalUsers(data.totalUsers || 0);
      setUserPoints(data.totalUserPoints || 0);
      setTodayUsers(data.todayUsers || 0);
      setLastWeekGrowth(data.lastWeekGrowth || "0.00");
      setTotalRevenue(data.totalRevenue || 0);
      setLastWeekRevenueGrowth(data.lastWeekRevenueGrowth || "0.00");

      // Keep /user/metrics as is
      const metrics = await axios.get("https://prod-erp.nifty10.in/user/metrics");
      const { totalSpent, spentGrowth, totalWinningPoints } = metrics.data;
      setTotalSpent(totalSpent || 0);
      setLastWeekSpentGrowth(spentGrowth || "0.00");
      setTotalWinningPoints(totalWinningPoints || 0);
    } catch (error) {
      console.error("Failed to fetch summary or metrics:", error.message);
    }
  };

  fetchSummary();
}, []);


    return (
        <div className="dashboard-container">
            <div className="all-cards-container dashboard-cards-container">
                <Card
                    key="userStats"
                    title="USER STATS"
                    image="./total-users.png"
                    color="Bullish"
                    newUsers={todayUsers}  // ✅ this must match the state variable
                    totalUsers={totalUsers}
                    growthRate={lastWeekGrowth}
                    duration={today.toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric"
                    })}
                    isUserCard
    navigateTo="users-info"
                />



                {/*
         * Card for Total Spent and Winning Points in one:
         * Uses the new flag isSpentWinningCard.
         */}
                <Card
                    key="spentAndWinning"
                    title={`BIDS STATS (${bidStatsDateStr})`}
                    color="Bank"
                    image="./total-spent.png"
                    data={totalSpent.toLocaleString()}
                    winningPoints={totalWinningPoints.toLocaleString()}
                    growthRate={lastWeekSpentGrowth}
                    duration="Last week"
                    isSpentWinningCard
                    navigateTo="user-bids"
                />


                {/*
         * Separate Card for Payouts.
         * In this example, we display Payouts (userPoints) as single data.
         * (Adjust labels inside Card component if needed.)
         */}
                <Card
                    key="Payouts"
                    title="PAYOUT STATS"
                    color="Bearish"
                    image="./payouts.png"
                    data={userPoints}
                    growthRate={last24HoursGrowth}
                    duration="Last 24hrs"
                    isPayoutCard
                />

                <Card
                    key="totalRevenue"
                    title="REVENUE STATS"
                    color="Nifty"
                    image="./total-revenue.png"
                    data={totalRevenue.toLocaleString()}
                    growthRate={lastWeekRevenueGrowth}
                    duration="Last week"
                    isRevenueCard
                />

            </div>
            <div className="dashboard-graph-todo">
                <BoxGraph />
                <GradientPie/>
                
            </div>
            <div className="dashboard-graph-todo">
            <SimpleLineChart/>
            <Todo/></div>
        </div>
    );
};

export default Dashboard;